import "./AlertTemplate.css";
const AlertTemplate = ({ style, options, message, close }) => {
  const alertTypeClass = options.type ? `alert-${options.type}` : "alert-info";
  return (
    <div
      className={`alert-container ${alertTypeClass}`}
      style={style} // The `react-alert` library passes inline positioning styles here
    >
      <span className="alert-info">{message}</span>
      <button onClick={close} className="alert-close">
        &times;
      </button>
    </div>
  );
};

export default AlertTemplate;
